import React from 'react';
import ScrollToTop from "./Tiltop";
import '../css/Fornyemedlemmer.css';
import { 
  FaShieldAlt, 
  FaHandsHelping, 
  FaGavel, 
  FaQuestionCircle, 
  FaEnvelope,
  FaGamepad,
  FaProjectDiagram,
  FaUsers
} from "react-icons/fa";


  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    section.scrollIntoView({ behavior: "smooth" });
  };

const Fornyemedlemmer = () => {
  return (
    <div className="mainmedlem">

      {/* HERO SECTION */}
      <section className="hero">
        <div className="hero-p">
          <h1>For nye <br/>medlemmer</h1>
          <p>
            Hos os er tryghed, respekt og fællesskab i centrum.
            Uanset om du er ny, nervøs, erfaren eller bare nysgerrig, er du altid velkommen.
            <br/> 
            På denne side kan du læse alt, hvad du behøver at vide, 
            før du besøger foreningen første gang.
          </p>
        </div>
        <img
          className="hero-img"
          src="open.jpeg"
          alt="Foreningens lokaler"
        />
      </section>






      {/* FEATURES / OFFERINGS */}
      <section className="featuresmedlem">
<div className="featuresmedlem-box" onClick={() => scrollToSection("omos")}>
  <div className="icon-text">
  <FaUsers className="icon" />
  <h3>Hvem er vi</h3>
  </div>
  <p>Inspirerende oplæg om gaming, digital dannelse og sociale kompetencer.</p>
</div>

<div className="featuresmedlem-box" onClick={() => scrollToSection("Praktisk")}>
  <div className="icon-text">
  <FaGamepad className="icon" />
  <h3>Praktisk</h3>
  </div>
  <p>Udvidede forløb, der kombinerer gaming med faglige mål og personlig udvikling.</p>
</div>

<div className="featuresmedlem-box" onClick={() => scrollToSection("forventinger")}>
  <div className="icon-text">
  <FaProjectDiagram className="icon" />
  <h3>Første gang?</h3>
  </div>
  <p>Praktiske workshops hvor elever lærer teamwork, problemløsning og kreativitet gennem spil.</p>
</div>

<div className="featuresmedlem-box" onClick={() => scrollToSection("tryghed")}>
  <div className="icon-text">
  <FaShieldAlt className="icon" />
  <h3>Trygheds<br/>repræsentant</h3>
  </div>
  <p>Skaber et sikkert og støttende miljø for alle deltagere.</p>
</div>

<div className="featuresmedlem-box" onClick={() => scrollToSection("hensyn")}>
  <div className="icon-text">
  <FaHandsHelping className="icon" />
  <h3>Hensyn</h3>
  </div>
  <p>Fokus på empati og respekt i samarbejde og spil.</p>
</div>

<div className="featuresmedlem-box" onClick={() => scrollToSection("regler")}>
  <div className="icon-text">
  <FaGavel className="icon" />
  <h3>regler</h3>
  </div>
  <p>Klare retningslinjer for adfærd og fair play.</p>
</div>

<div className="featuresmedlem-box" onClick={() => scrollToSection("oss")}>
  <div className="icon-text">
  <FaQuestionCircle className="icon" />
  <h3>FAQ</h3>
  </div>
  <p>Svar på ofte stillede spørgsmål omkring forløbene.</p>
</div>

<div className="featuresmedlem-box" onClick={() => scrollToSection("Kontakt")}>
  <div className="icon-text">
  <FaEnvelope className="icon" />
  <h3>Kontakt</h3>
  </div>
  <p>Kontakt os for spørgsmål eller yderligere information.</p>
</div>
    </section>




      <section className="tekstmedlem" >
      <div class="article">
      <section className="omos" id="omos">
        <h2>Hvem er vi</h2>
        <p>
          Vi er en forening, der arbejder for at skabe et inkluderende og trygt 
          fællesskab, hvor alle kan føle sig hjemme.
          Hos os er der plads til forskellighed og vi møder hinanden med åbenhed og respekt.
          <br/>
          Vores værdier bygger på:
          <ul className="module-list">
            <li>Tryghed</li>
            <li>Omsorg </li>
            <li>Fællesskab</li>
            <li>Respekt</li>
          </ul>

          Foreningenen er for dig som elsker gaming og esport.
          Lige meget aldre, køn og baggrund    
        </p>
      </section>
      <br/><br/>



        <section className="Praktisk" id="Praktisk">
        <h2>Praktisk information</h2>
        <p>
        <span className="gold">Adresse:</span> Nyelandsvej 51 2000 Frederiksberg.
        <br/>
        <span className="gold">Åbningstider:</span> Søndag kl. 17:00 - 21.00.
        <br/>
        <span className="gold">Første gang:</span> Gratis og helt uforpligtende.
        <br/><br/>
        <span className="gold">kontingent</span> er 2000 kr. for 6 måneder.
        <br/>giver adgang til
        <ul className="module-list">
          <li>Fri afgang til lokalet i åbningstider</li>
          <li>Mad og drikke i lokalet</li>
          <li>2 timer træning om ugen</li>
          <li>Professionel træner</li>
          <li>En personlig manager, som støtter dig i din udvikling.</li>
          <li>fælleskabs aktiviteter med pengepræmier. </li>
          <li>Mulighed for deltagelse i fysiske events, Bootcamps og turneringer. </li>
        </ul>    
        Vi har alt udstyr, men det er muligt at tage egen mus og tastatur samt headset med.
        </p>
      </section>
      <br/><br/>


      <section className="forventinger" id="forventinger">
        <h2>Første gang?</h2>
        <p>
        Det er helt normalt at være lidt spændt eller nervøs første gang.
        Når du ankommer, vil du blive mødt af en frivillig eller ansvarlig person, 
        som kan vise dig rundt og svare på dine spørgsmål.
        <br/><br/>
        Du bestemmer selv, om du vil deltage aktivt eller bare kigge med.
        Der er ingen forventninger kun plads til at være dig selv.
        <br/><br/>
        Der er holdtræninger som man kan tilmelde sig til. 
        men du kan også bare komme og kigge eller prøve nogle af de andre 
        maskiner som VR, PS, Nitendo 
        og vis det ikke er noget er der også plads til en omgang brædt spil.
        </p>
      </section>
      <br/><br/>



<section className="tryghed-hensyn" id="hensyn">
  <h2>Tryghed, sikkerhed & hensyn</h2>

  {/* Tryghed & sikkerhed */}
  <div className="tryghed-info">
    <p>
    Din tryghed er vigtig for os. Vi bestræber os på at skabe et 
    inkluderende og trygt miljø for alle. Har du særlige behov, eller er der 
    noget, vi skal tage ekstra hensyn til, er du altid velkommen til at kontakte os på forhånd.
    </p>
    <p>
    Vi har plads til kørestole, handicaptoiletter samt mulighed 
    for pauser undervejs. Der er god plads og forståelse for personer 
    med særlige behov herunder angst, autisme og nybegyndere. Vores erfarne 
    pædagogiske medarbejdere står klar til at støtte og hjælpe, så alle får en god oplevelse.
    </p>
    <ul className="module-list">
      <li>Handicapadgang</li>
      <li>Toiletforhold</li>
      <li>Mulighed for pauser</li>
      <li>Plads til særlige behov (fx angst, autisme, nybegyndere)</li>
    </ul>
  </div>


  {/* Tilgængelighed & hensyn */}
  <div className="hensyn-info" id="tryghed">
    <h3>Tryghedsrepræsentant:</h3>
      <br/>
      <span className="gold">Tryghedsrepræsentant:</span> Lui Børgesen<br/>
      <span className="gold">Mail:</span> Lui@linxlegacy.dk
  </div>
</section>
<br/><br/>



      <section className="regler" id="regler">
      <h2>Vores fælles retningslinjer</h2>
      <p>
      For at alle kan føle sig trygge, har vi nogle enkle retningslinjer:
      <br/>
      <ul className="module-list">
      <li>Vi taler ordentligt og respektfuldt til hinanden</li>
      <li>Chikane, diskrimination og grænseoverskridende adfærd tolereres ikke</li>
      <li>Vi respekterer hinandens grænser og forskelligheder</li>
      <li>Alkohol, stoffer og vold er ikke tilladt i foreningen</li>
      </ul>
      Reglerne er her for at passe på fællesskabet ikke for at begrænse det.
      </p>
      </section>
      <br/><br/>


      <section className="oss" id="oss">
        <h2>Ofte stillede spørgsmål</h2>
        <p>
        <h4>Handicapadgang</h4>
        der er adgang til handicaptoiletter og Handicaprammpe
        </p>

        <p>
        <h4>Mulighed for pauser</h4>
        Alt bliver taget i den inkeltes tempo 
        </p>

         <p>
        <h4>Plads til særlige behov</h4>
        Vores erfarne pædagogiske medarbejdere står klar til 
        alle de behov der måtte være
        <br/> 
        altid velkommen til at kontakte tryghedsrepræsentant på Lui@linxlegacy.dk
        </p>
      </section><br/><br/>




      <section className="Kontakt" id="Kontakt">
        <h2>Kontakt os</h2> 
        <p>
        Har du spørgsmål, brug for yderligere information eller ønsker at tale med os, er du altid 
        velkommen til at kontakte os på <br/>
        <span className="gold">E-mail:</span>
        <a href="mailto:kontakt@linxlegacy.dk"> Academy@linxlegacy.dk</a>
        </p>

      </section>


     </div>


<aside className="facts">
  <div className="facts-images">
    <div className="fact-item">
      <img src="/1.jfif" alt="Digital trivsel" />
    </div>

    <div className="fact-item">
      <img src="/2.png" alt="Digitale fællesskaber" />
    </div>

    <div className="fact-item">
      <img src="/3.jpeg" alt="Workshop" />
    </div>

    <div className="fact-item">
      <img src="/4.jpeg" alt="Moduler" />
    </div>

    <div className="fact-item">
      <img src="/6.jfif" alt="Gaming" />
    </div>

    <div className="fact-item">
      <img src="/7.jfif" alt="Gaming" />
    </div>

    <div className="fact-item">
      <img src="/8.jfif" alt="Gaming" />
    </div>
  </div>
</aside>



       </section>
      <ScrollToTop />
    </div>
  );
};


export default Fornyemedlemmer;